import angular from 'angular';
import productsListComponent from './products-list.component';
import PriceFilterModule from './price-filter/price-filter';
import DynamicFiltersModule from './dynamic-filters/dynamic-filters';

let productsListModule = angular.module('productsList',[
  PriceFilterModule.name,
  DynamicFiltersModule.name
])
  .component('productsList', productsListComponent);

export default productsListModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/products-list/products-list.js
 **/